import React, { useEffect, useState } from "react";
import { fetchMappingData } from "../../redux/actions/crmActions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  fetchHubspotMappingData,
  getSyncFields,
  submitHubspotMappingData,
} from "../../redux/actions/settingActions";
import { FaArrowRight } from "react-icons/fa";
import { ArrowRight } from "react-bootstrap-icons";
import * as Icon from "react-bootstrap-icons";
import Toast from "../assetLibComponents/shared/Toast";
import { FaCircleCheck } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const SettingHubspotMapping = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const mappingData = useSelector((state) => state.crmLeads.fetchMappingData);
  const fData = useSelector((state) => state.setting.fieldsData);
  const hubspotSelectedData = useSelector(
    (state) => state.setting.hubspotMappedData
  );
  const [newArr, setNewArr] = useState(fData?.hubspot_fields);
  const [newData, setNewData] = useState(hubspotSelectedData);

  useEffect(() => {
    dispatch(fetchMappingData(props.authToken));
    dispatch(fetchHubspotMappingData(props.authToken));
    dispatch(getSyncFields(props.authToken));

    if (mappingData) {
      setNewArr(fData?.hubspot_fields);
      // function transformArrayToObject(mappingData) {
      //   const result = {};

      //   mappingData.forEach((item) => {
      //     result[item.value] = "";
      //   });

      //   return result;
      // }
      // const transformedObject = transformArrayToObject(mappingData);
      // setNewData(transformedObject);
    }
  }, []);

  const handleSelect = (key, value) => {
    const newValue = newArr?.filter((item) => item?.label === value);
    // console.log(newValue)
    // Check if the key exists in the object
    if (newData.hasOwnProperty(key)) {
      // Update the value for the specified key
      const updatedData = { ...newData };

      // Update the value for the specified key
      updatedData[key] = newValue[0];
      setNewData(updatedData);
      // const resultArray = state?.header.filter(item => !Object.values(updatedData).includes(item));
      // setNewArr(resultArray)
      // Set the updated state
    } else {
      console.error(`Key '${key}' does not exist in the object.`);
    }
  };

  function hasEmptyValue(obj) {
    for (const key in obj) {
      if (
        obj.hasOwnProperty(key) &&
        (obj["domain"] === "" || obj["email"] === "")
      ) {
        return true; // Found a key with an empty value
      }
    }
    return false; // No key with an empty value found
  }
  function addMapping(arr, obj) {
    return arr.map((item) => ({
      ...item,
      map_label: obj[item.value]?.label ?? "", // hubspot label
      map_value: obj[item.value]?.name ?? "", // hubspot name
      map_field_type: obj[item.value]?.fieldType ?? "", // hubspot field_type
      map_type: obj[item.value]?.type ?? "", // hubspot type
      hubspot_options: obj[item.value]?.options ?? "", // hubspot type
    }));
  }

  const submitHandler = () => {
    if (hasEmptyValue(newData)) {
      Toast("Please fill all the fields", "E");
    } else {
      const newArrr = addMapping(mappingData, newData);
      dispatch(submitHubspotMappingData(props.authToken, newArrr, onSuccess));
      //  dispatch(submitMappingData(props.authToken, newData, item,newArr));
    }
  };
  
  const onSuccess = () => {
    navigate("/Setting/hubspot");
  }

  const isObjectPresent = (obj, targetObj) =>  {
    // Extract the label property from the target object
    const targetLabel = targetObj.fieldId;

    // Check if any object within the main object has a label property equal to the target label
    for (const key in obj) {
        if (obj?.hasOwnProperty(key) && obj[key]?.fieldId === targetLabel) {
            return true;
        }
    }

    // If no match is found, return false
    return false;
}

  return (
    <>
      <div className="py-2">
        <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
          <div className="text-lg leading-7 font-[500] my-auto">
            Lead Mapping
          </div>
          <div className="flex items-center">
            <button
              onClick={()=>{navigate("/Setting/hubspot")}}
              type="button"
              className="mr-4 inline-flex border border-gray-300 items-center gap-x-1.5 rounded-md bg-transparent hover:bg-[#bcc2c3] px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm"
            >
              <Icon.ChevronLeft className="text-[#000000]"/> <span>Back</span>
            </button>
            <button
              onClick={submitHandler}
              type="button"
              className="mr-4 max-sm:mr-0 inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] px-3 py-2 text-sm font-semibold text-white shadow-sm"
            >
              Save Changes
            </button>
          </div>
        </div>
        <div className="overflow-auto h-[68vh] syncField">
          <div className="mt-2 flow-root">
            <div className="-my-2 overflow-x-auto ">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-1">
                <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                  <table className="min-w-full max-sm:w-[800px] divide-y divide-gray-300">
                    <thead className="bg-gray-50">
                      <tr>
                        <th
                          scope="col"
                          className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                        >
                          Zoi Property
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Field Type
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Mapped
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Hubspot Selected Fields
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {mappingData?.map((item) => (
                        <tr key={item.display}>
                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                            {item.display}
                            {(item?.value === "email" ||
                              item?.value === "company_website") &&
                              "*"}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 capitalize">
                            {item?.object_type}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            {newData[item?.value] !== "" ? (
                              <FaCircleCheck className="text-green-500 text-2xl" />
                            ) : (
                              ""
                            )}
                          </td>

                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            <select
                            disabled={(item?.value === "email" ||
                            item?.value === "company_website")}
                              id="leads"
                              name="leads"
                              onChange={(e) =>
                                handleSelect(item.value, e.target.value)
                              }
                              value={newData[item?.value]?.label}
                              className={`mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[#49BCD2] sm:text-sm sm:leading-6`}
                            >
                              <option value="">Select {item.display}</option>
                              {newArr?.filter(option => option?.object_type === item?.object_type)?.map((option, i) => (
                                <option
                                  key={i}
                                  value={option?.label}
                                  disabled={isObjectPresent(newData, option)}
                                >
                                  {option?.label}
                                </option>
                              ))}
                            </select>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingHubspotMapping;
